import axios from 'axios';
import Cookie from 'js-cookie'

const request = axios.create({
    timeout: 3000,
    timeoutErrorMessage: '请求超时',
    //baseURL:"https://api.safer.yooar.com/company",
})

request.defaults.baseURL = process.env.NODE_ENV == 'development' ? '/company' : 'https://feedbackadmin.yooar.com/adminapi/company'
//  请求拦截
request.interceptors.request.use((config) => {
    // 如果本地有token  就在请求头上添加token 如果没有 就不添加
    if (Cookie.get("token")) {
        config.headers.authorization = Cookie.get('token')
    }
    return config
}, (err) => {
    return Promise.reject(err)
})


// 响应拦截
request.interceptors.response.use((config) => {
    return config.data;
}, (err) => {

    return Promise.reject(err)
})
export default request
